<template>
  <activity-view
    action-label="commented"
    :award-context="awardContext"
    :created-at="activity.createdAt"
    :show-entity-info="showEntityInfo"
    :show-team-org-name="showTeamOrgName"
    :activity="activity"
    :theme-color="themeColor"
    :comment="activity.comment"
    :goal="goal"
    :project="project"
    @awarded="$emit('awarded')"
    @reacted="$emit('reacted')"
  >
  </activity-view>
</template>

<script>
import ActivityView from '@/components/activity/ActivityView'
import getActivityEntityType from '@/components/activity/utils/getActivityEntityType'
import { ENTITY_TYPE } from '@/constants/entities'
import * as R from 'ramda'
import getEventAwardContext from '@/utils/getEventAwardContext'

/**
 * This component gives view for comment activity on Initiative
 */
export default {
  name: 'CommentActivity',
  components: {
    ActivityView
  },
  props: ['activity', 'showEntityInfo', 'themeColor', 'showTeamOrgName', 'goal', 'project'],
  data() {
    const isAwardable = this.isActivityAwardable()
    return {
      awardContext: isAwardable ? this.getAwardContext() : null
    }
  },
  methods: {
    isActivityAwardable() {
      const entityType = getActivityEntityType(this.activity)
      return [ENTITY_TYPE.GOAL, ENTITY_TYPE.INITIATIVE].includes(entityType)
    },
    getAwardContext() {
      const entityType = getActivityEntityType(this.activity)
      const entity = entityType === ENTITY_TYPE.GOAL ? this.activity.goal : this.activity.initiative
      let entityInfo = {}
      if (entityType === ENTITY_TYPE.GOAL) {
        entityInfo = { goalId: entity.id }
      } else if (entityType === ENTITY_TYPE.INITIATIVE) {
        entityInfo = { initiativeId: entity.id }
      }
      return {
        ...getEventAwardContext(this.activity, entityType, R.prop('title', entity)),
        ...entityInfo
      }
    }
  }
}
</script>
